<template>
  <div class="slide-show-container">
  <img :src="items[counter].img"  />
    <div class="caption">
      <p>
        {{ items[counter].title }}
      </p>
      <p>
        {{ items[counter].description }}
      </p>
    </div>
    <div v-if="items.length > 1" class="counter">
      <i class="fa fa-chevron-left" @click="next()" />
      <div class="dots">
        <div
          v-for="index in items.length"
          :key="index"
          :class="[
            'dot-item',
            { 'selected': index - 1 === counter },
          ]"
          @click="changeIndex(index - 1)"
        />
      </div>
      <i class="fa fa-chevron-right" disabled="true" @click="prev()" />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    counter: 0,
  }),
  created() {
    this.counter = this.currentIndex;
  },
  methods: {
    next() {
      if (this.counter === this.items.length - 1) {
        return;
      }
      this.counter++;
    },
    prev() {
      if (this.counter === 0) {
        return;
      }
      this.counter--;
    },
    changeIndex(newIndex) {
      this.counter = newIndex;
    },
  },
};
</script>

<style lang="scss">

.slide-show-container {

  > img {
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-bottom: 3rem;

    :first-child {
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.7;
      color: white;
      animation: rotator;
    }

    :last-child {
      color: #F7F7FC;
      animation: rotator;
    }

  }

  .counter {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 0.25rem;

    > i {
      color: white;
      cursor: pointer;
      transition: 0.6s ease;
    }

    .dots {
      width: 12.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row-reverse;
      gap: 0.5rem;

      > * {
        border-radius: 0.75rem;
      }

      .dot-item {
        background-color: #BCA4FF;
        cursor: pointer;
        height: 0.25rem;
        width: 1.5rem;

        &.selected {
          width: 2rem;
          background-color: white;
          transition: background-color 1.5s ease;
        }

      }
    }

  }

  .fade {
    animation-name: fade;
    animation-duration: 1.5s;
    opacity: 1;
  }

  @keyframes fade {
    from {
      opacity: 0.4;
    }
    to {
      opacity: 1;
    }
  }
}
</style>
